import * as React from 'react';
const SvgCross = (props) => (
  <svg width={53} height={53} viewBox="0 0 53 53" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M39.5204 13.1299L26.2604 26.3899L39.5204 39.6499"
      stroke="#936888"
      strokeWidth={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.2601 39.6501L26.5201 26.3901L13.2601 13.1301"
      stroke="#936888"
      strokeWidth={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgCross;
